import { connect } from 'react-redux';
import HomeScreenCardModal from './HomeScreenCardModal';
import { fetchHomeScreenCards } from '../../actions/home';
import getErrorMessage from '../../../lib/utils/getErrorMessage';
import settings from '../../../lib/utils/settings';
import { performFirstPartyTracking } from '../../actions/analytics';

function mapStateToProps({ home }) {
  const { isFetching, error, cards } = home;
  const { nextHomeScreenCardInterval } = settings;

  return {
    isFetching,
    error: getErrorMessage(error),
    cards,
    nextInterval: nextHomeScreenCardInterval,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchHomeScreenCards: () => dispatch(fetchHomeScreenCards()),
    performFirstPartyTracking: event => dispatch(performFirstPartyTracking(event)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreenCardModal);
